import { statusStyles } from '../styles/tokens'

export default function StatusBadge({ status }) {
  const style = statusStyles[status] || statusStyles.draft
  const label = status
    ? status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
    : 'Unknown'

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '3px 10px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 600,
        background: style.bg,
        color: style.text,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  )
}
